import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getFAIcon } from './icons';
import { FaIconName } from './types';

type PropTypes = {
  name: string;
};

export const AmenityIcon = ({ name }: PropTypes) => (
  <FontAwesomeIcon icon={getFAIcon(name as FaIconName)} />
);
